<template>
<div class="chapter">
<div class="inner_page">
<div class="box1">
<p class="dedi"><em class="italic"><a id="page_6">Dedicated</a></em></p><a id="page_6">
<p class="dedit"><em class="italic">to those who struggle to know trust</em></p>
<p class="dedit1"><em class="italic">and to find the place of heart.</em></p>
</a></div><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?42842dde